import { Icon } from '../../ui/Icon'
import { Select } from '../../ui/Select'
import { payText } from '../orders/model'
import type { ChannelKey, ChannelsDraft, MainChannel, PaymentChannels } from './api'

export interface PaymentChannelsCardProps {
  channels: PaymentChannels
  draft: ChannelsDraft
  /** Переключает только супер-админ (R-113); остальные видят, что включено. */
  editable: boolean
  onChange: (draft: ChannelsDraft) => void
}

const isPage = (key: ChannelKey): key is MainChannel => key !== 'cards'

/**
 * Каналы онлайн-оплаты: Welcome, сохранённые карты и Rahmat. Каждый —
 * переключатель и способы, которые он приносит. Когда включены обе страницы
 * оплаты, карту, Click, Payme и Uzum берёт главная — её выбирают здесь же.
 * Сохраняется общей кнопкой карточки интеграции; `PUT /admin/payment/channels`
 * принимает только супер-админа (role_id 1).
 */
export function PaymentChannelsCard({
  channels,
  draft,
  editable,
  onChange,
}: PaymentChannelsCardProps) {
  // Главной может быть только страница оплаты, не сохранённые карты.
  const pages = channels.channels.flatMap((c) =>
    isPage(c.key) ? [{ value: c.key, label: c.title }] : [],
  )

  return (
    <section className="ui-card" aria-labelledby="int-channels">
      <div className="ui-card-head">
        <h3 id="int-channels">Каналы оплаты</h3>
        {editable ? null : (
          <span className="aside">
            <Icon name="i-key" />
            переключает супер-админ
          </span>
        )}
      </div>
      <div className="ui-card-body ui-form">
        <div className="ui-facts">
          {channels.channels.map((channel) => (
            <div key={channel.key}>
              <span className="k">
                <label className="ui-switch" data-size="sm">
                  <input
                    type="checkbox"
                    role="switch"
                    checked={draft[channel.key]}
                    disabled={!editable}
                    onChange={(e) => {
                      onChange({ ...draft, [channel.key]: e.target.checked })
                    }}
                  />
                  {channel.title}
                </label>
              </span>
              <span className="v int-channel">
                {channel.methods.map(payText).join(', ') || '—'}
                {channel.connected ? null : (
                  <span className="ui-status" data-tone="warning">
                    нет ключей
                  </span>
                )}
              </span>
            </div>
          ))}
        </div>
        {draft.wlcm && draft.rahmat ? (
          <div className="ui-field">
            <span className="ui-label" aria-hidden="true">
              Карта, Click, Payme и Uzum идут через
            </span>
            <Select
              label="Главная страница оплаты"
              value={draft.main}
              disabled={!editable}
              options={pages}
              onChange={(main) => {
                onChange({ ...draft, main })
              }}
            />
          </div>
        ) : null}
      </div>
    </section>
  )
}
